<div class="fah-topbar" role="banner" (click)="$event.stopPropagation()">
  <div class="fah-inner">
    <div class="fah-left">
      <a
        class="fah-brand"
        data-testid="header-brand"
        [routerLink]="brandLink()"
        (click)="trackBrandClick()"
      >
        FrontendAtlas
      </a>
      <button
        type="button"
        #mobileStudyTrigger
        class="fah-mobile-study"
        data-testid="header-mobile-study-button"
        (click)="toggleMega($event)"
        [attr.aria-expanded]="megaOpen()"
        aria-controls="prepare-mega"
        [class.fah-mobile-study--active]="megaOpen() || isStudyActive()"
        aria-label="Open interview prep menu"
      >
        <i class="pi pi-book" aria-hidden="true"></i>
        <span class="fah-mobile-study-label fah-mobile-study-label--full">Interview Prep</span>
        <span class="fah-mobile-study-label fah-mobile-study-label--short">Prep</span>
        <span class="caret" aria-hidden="true">▾</span>
      </button>
    </div>

    <div class="fah-center">
      <button
        type="button"
        #desktopStudyTrigger
        class="fah-navlink"
        [class.fah-navlink--active]="megaOpen() || isStudyActive()"
        (click)="toggleMega($event)"
        [attr.aria-expanded]="megaOpen()"
        aria-controls="prepare-mega"
      >
        Interview Prep <span class="caret" aria-hidden="true">▾</span>
      </button>
      <a
        class="fah-navlink"
        data-testid="header-interview-hub"
        routerLink="/interview-questions"
        [class.fah-navlink--active]="isInterviewQuestionsActive()"
        [attr.aria-current]="isInterviewQuestionsActive() ? 'page' : null"
        (click)="onInterviewQuestionsClick()"
      >
        Interview Questions
      </a>
    </div>

    <div class="fah-right" (click)="$event.stopPropagation()">
      <div
        class="fah-desktop-actions"
        [attr.aria-busy]="auth.authUiState() === 'pending' ? 'true' : null"
      >
        <div
          *ngIf="auth.authUiState() === 'pending'; else desktopAuthResolved"
          class="fah-auth-pending"
          data-testid="header-auth-pending"
          aria-hidden="true"
        >
          <span class="fah-auth-placeholder fah-auth-placeholder--avatar"></span>
          <span class="fah-auth-placeholder fah-auth-placeholder--cta"></span>
        </div>

        <ng-template #desktopAuthResolved>
          <a
            *ngIf="auth.authUiState() === 'signed_out'"
            class="fah-navlink fah-pricing-link"
            data-testid="header-pricing-link"
            routerLink="/pricing"
            routerLinkActive="fah-navlink--active"
            (click)="onPricingClick()"
          >
            Pricing
          </a>
          <div class="fah-profile fah-profile-right">
            <button
              type="button"
              class="fah-avatar"
              data-testid="header-profile-button"
              (click)="toggleProfileMenu($event)"
              aria-haspopup="menu"
              [attr.aria-label]="profileOpen() ? 'Close account menu' : 'Open account menu'"
              [attr.aria-expanded]="profileOpen()"
            >
              <i class="pi pi-user"></i>
            </button>
            <div *ngIf="profileOpen()" class="fah-menu" role="menu" data-testid="header-profile-menu" (click)="$event.stopPropagation()">
              <div class="fah-menu-section">Account</div>

              <ng-container *ngIf="auth.authUiState() === 'authenticated'; else profileDisabled">
                <a class="fah-menu-item" routerLink="/profile" (click)="closeAll()" data-testid="header-menu-profile">
                  <i class="pi pi-user"></i> My profile
                </a>
                <a *ngIf="isAdmin()" class="fah-menu-item" routerLink="/admin/users" (click)="closeAll()" data-testid="header-menu-admin-users">
                  <i class="pi pi-shield"></i> Admin: Users
                </a>
                <div class="fah-divider"></div>
                <button class="fah-menu-item" (click)="logout()" data-testid="header-menu-logout"><i class="pi pi-sign-out"></i> Log out</button>
              </ng-container>

              <ng-template #profileDisabled>
                <button class="fah-menu-item" routerLink="/auth/signup" (click)="closeAll()" data-testid="header-menu-signup">
                  <i class="pi pi-user-plus"></i> Sign up
                </button>
                <button class="fah-menu-item" routerLink="/auth/login" (click)="closeAll()" data-testid="header-menu-login">
                  <i class="pi pi-sign-in"></i> Log in
                </button>
              </ng-template>
            </div>
          </div>

          <a
            class="fah-cta fah-cta-solid"
            [routerLink]="ctaLink()"
            (click)="trackUtilityClick(ctaDestination())"
          >
            {{ ctaLabel() }}
          </a>
        </ng-template>
      </div>

      <div
        class="fah-mobile-actions"
        [attr.aria-busy]="auth.authUiState() === 'pending' ? 'true' : null"
      >
        <span
          *ngIf="auth.authUiState() === 'pending'"
          class="fah-auth-placeholder fah-auth-placeholder--mobile-avatar"
          data-testid="header-mobile-auth-pending"
          aria-hidden="true"
        ></span>
        <a
          *ngIf="auth.authUiState() === 'authenticated'"
          class="fah-avatar fah-profile--mobile-link"
          data-testid="header-mobile-profile-button"
          routerLink="/profile"
          (click)="trackUtilityClick('/profile')"
          aria-label="Open profile"
        >
          <i class="pi pi-user"></i>
        </a>
        <button
          type="button"
          class="fah-iconbtn"
          data-testid="header-mobile-menu-button"
          (click)="toggleSidebarDrawer($event)"
          [attr.aria-expanded]="sidebarDrawerOpen()"
          aria-controls="app-sidebar-drawer"
          [attr.aria-label]="sidebarDrawerOpen() ? 'Close sidebar' : 'Open sidebar'"
        >
          <i class="pi" [ngClass]="sidebarDrawerOpen() ? 'pi-times' : 'pi-bars'"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="megaOpen()" class="fah-backdrop" (click)="closeAll()"></div>
  <app-prep-menu-panel
    panelId="prepare-mega"
    testIdPrefix="header-study"
    [open]="megaOpen()"
    [currentPath]="currentPath()"
    [anchorX]="megaAnchorX()"
    [searching]="isSearching()"
    [highlightKey]="highlightKey()"
    [(activeSection)]="prepSection"
    (itemSelected)="onPrepItemSelected($event)"
    (click)="$event.stopPropagation()"
  >
    <ng-container ngProjectAs="[prepMenuTop]">
      <div *ngIf="megaOpen()" class="study-top">
        <div class="study-search">
          <i class="pi pi-search" aria-hidden="true"></i>
          <input
            #studySearchInput
            type="text"
            aria-label="Search interview prep"
            autocomplete="off"
            [value]="searchTerm"
            (input)="onSearchInput($event)"
            (keydown)="onSearchKeydown($event)"
            placeholder="Search guides, companies, or practice"
          />
          <span class="shortcut" aria-hidden="true">/</span>
        </div>

        <a
          *ngIf="!isSearching()"
          class="study-row"
          data-testid="header-study-continue"
          [class.active]="activeIndex() === 0"
          [routerLink]="continueAction().route"
          (click)="onContinueClick()"
        >
          <div class="row-icon"><i class="pi pi-history" aria-hidden="true"></i></div>
          <div class="row-body">
            <div class="row-title">
              {{ continueAction().title }}
              <span *ngIf="continueAction().badge" class="badge">{{ continueAction().badge }}</span>
            </div>
            <div class="row-sub">{{ continueAction().subtitle }}</div>
          </div>
          <div class="row-meta"><i class="pi pi-arrow-right" aria-hidden="true"></i></div>
        </a>

        <div *ngIf="isSearching()" class="study-section">
          <div class="study-section__title">Results</div>
          <div class="study-list">
            <ng-container *ngFor="let item of searchResults(); trackBy: trackByItemKey; let idx = index">
              <div *ngIf="item.disabled || !intentToLink(item); else searchRow" class="study-row disabled" role="button" aria-disabled="true">
                <div class="row-icon"><i class="pi" [ngClass]="item.pi"></i></div>
                <div class="row-body">
                  <div class="row-title">
                    {{ item.title }}
                    <span *ngIf="item.badge" class="badge">{{ item.badge }}</span>
                  </div>
                  <div class="row-sub">{{ item.subtitle }}</div>
                </div>
                <div class="row-meta"><span class="badge">{{ item._group }}</span></div>
              </div>
              <ng-template #searchRow>
                <a
                  class="study-row"
                  [class.active]="activeIndex() === rowIndex('search-' + idx)"
                  [routerLink]="intentToLink(item)!"
                  (click)="onItemNavigate(item)"
                >
                  <div class="row-icon"><i class="pi" [ngClass]="item.pi"></i></div>
                  <div class="row-body">
                    <div class="row-title">
                      {{ item.title }}
                      <span *ngIf="item.badge" class="badge">{{ item.badge }}</span>
                    </div>
                    <div class="row-sub">{{ item.subtitle }}</div>
                  </div>
                  <div class="row-meta">
                    <span class="badge">{{ item._group }}</span>
                    <i class="pi pi-arrow-right"></i>
                  </div>
                </a>
              </ng-template>
            </ng-container>
            <div *ngIf="!searchResults().length" class="empty-state">No matches</div>
          </div>
        </div>
      </div>
    </ng-container>
  </app-prep-menu-panel>
</div>
